import Login from './views/Login.vue'
import admin from './views/user/admin.vue'
import masterUser from './views/user/masterUser.vue'
import merchant from './views/user/merchant.vue'
import worker from './views/user/worker.vue'
import installOrder from './views/order/installOrder'
import cancelOrder from './views/order/cancelOrder'
import skillManage from './views/user/skillManage'
import applyCashManage from './views/applyCash/applyCashManage.vue'
import merchantMoneyLog from './views/log/merchantMoneyLog'
import masterMoneyLog from './views/log/masterMoneyLog'
import revenueExpenditureAccount from './views/charts/revenueExpenditureAccount'
import smsLog from './views/log/smsLog'
import carManage from './views/product/carManage'
import productList from './views/product/productList'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import Main from './views/Main.vue'
import echarts from './views/charts/echarts.vue'
import workerOrderSta from './views/charts/workerOrderSta.vue'
import Apply from './views/apply'

let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },

    {
        path: '/',
        component: Home,
        name: '数据统计',
        iconCls: 'fa fa-bar-chart-o',
        children: [
            {path: '/echarts', component: echarts, name: '统计概览'},
            {path: '/workerOrderSta', component: workerOrderSta, name: '员工提成统计'},
            {path: '/revenueExpenditureAccount', component: revenueExpenditureAccount, name: '收支台账'}
        ]
    },
    {
        path: '/',
        component: Home,
        name: '用户管理',
        iconCls: 'fa fa-user-o',
        children: [
            /* { path: '/admin', component: admin, name: '管理员' },*/
            {path: '/merchant', component: merchant, name: '商家'},
            {path: '/worker', component: worker, name: '员工'},
            {path: '/masterUser', component: masterUser, name: '工程师'},
            {path: '/skillManage', component: skillManage, name: '技能管理'}

        ]
    },
    {
        path: '/',
        component: Home,
        name: '订单管理',
        iconCls: 'fa fa-list',
        children: [
            {path: '/installOrder', component: installOrder, name: '安装订单'},
            {path: '/installOrder?index=1', component: installOrder, name: '冀辽吉黑浙蒙'},
            {path: '/installOrder?index=2', component: installOrder, name: '川皖鲁湘鄂桂闽宁豫'},
            {path: '/installOrder?index=3', component: installOrder, name: '津沪琼滇赣苏新藏青'},
            {path: '/installOrder?index=4', component: installOrder, name: '粤渝京'},
            {path: '/installOrder?index=5', component: installOrder, name: '晋贵陕甘'},
            {path: '/cancelOrder', component: cancelOrder, name: '退订订单'}
        ]
    },
    {
        path: '/',
        component: Home,
        name: '产品管理',
        iconCls: 'fa fa-car',
        children: [
            {path: '/productList', component: productList, name: '产品列表'},
            {path: '/carManage', component: carManage, name: '车型管理'}
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        leaf: true,
        iconCls: 'fa fa-money',
        children: [
            {path: '/applyCashManage', component: applyCashManage, name: '提现管理'}
        ]
    },
    {
        path: '/',
        component: Home,
        name: '日志管理',
        iconCls: 'fa fa-id-card-o',
        children: [
            {path: '/merchantMoneyLog', component: merchantMoneyLog, name: '商家余额日志'},
            {path: '/masterMoneyLog', component: masterMoneyLog, name: '工程师余额日志'},
            {path: '/smsLog', component: smsLog, name: '短信发送日志'}

        ]
    },


    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/apply',
        component: Apply,
        name: '',
        hidden: true
    },


    {
        path: '*',
        hidden: true,
        redirect: {path: '/404'}
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js